import { useEffect, useRef, useState } from "react";

interface Props {
  label: string;
  value: number;
  min: number;
  max: number;
  step: number;
  decimals?: number;
  unit: string;
  onChange: (value: number) => void;
}

/** Preserve partial input while typing; only valid values reach the audio engine. */
export function FrequencyValue({ label, value, min, max, step, decimals = 0, unit, onChange }: Props) {
  const [draft, setDraft] = useState(value.toFixed(decimals));
  const editing = useRef(false);
  useEffect(() => { if (!editing.current) setDraft(value.toFixed(decimals)); }, [value, decimals]);
  return <label><input aria-label={label} type="number" min={min} max={max} step={step} value={draft}
    onFocus={event => { editing.current = true; event.currentTarget.select(); }}
    onChange={event => {
      setDraft(event.currentTarget.value);
      const next = event.currentTarget.valueAsNumber;
      if (Number.isFinite(next) && next >= min && next <= max) onChange(next);
    }}
    onBlur={event => {
      editing.current = false;
      const entered = event.currentTarget.valueAsNumber;
      const next = Number.isFinite(entered) ? Math.min(max, Math.max(min, entered)) : value;
      setDraft(next.toFixed(decimals));
      if (next !== value) onChange(next);
    }}
    onKeyDown={event => { if (event.key === "Enter") { event.preventDefault(); event.currentTarget.blur(); } }}
  /><span>{unit}</span></label>;
}
